<div class="mine-page container py-4">
  <div class="d-flex flex-wrap justify-content-between align-items-start gap-3 mb-4">
    <div>
      <h1 class="mine-title mb-1">My shared templates</h1>
      <p class="mine-subtitle mb-0">
        Templates you submitted to the catalogue — including pending and denied ones.
      </p>
    </div>
    <button type="button" class="btn btn-outline-secondary" (click)="goCatalogue()">
      Back to catalogue
    </button>
  </div>

  <div *ngIf="loading" class="text-center py-5">
    <mat-spinner diameter="40" class="mx-auto"></mat-spinner>
  </div>

  <div *ngIf="!loading && templates.length === 0" class="empty-state text-center py-5">
    <mat-icon class="empty-icon">inventory_2</mat-icon>
    <p class="mb-2 mt-2">You have not shared any templates yet.</p>
    <p class="empty-hint mb-0">
      Share one from a guild’s signup template editor with
      <strong>Share to catalogue</strong>.
    </p>
  </div>

  <div *ngIf="!loading && templates.length" class="mine-list">
    <button
      type="button"
      class="mine-card"
      *ngFor="let template of templates"
      (click)="open(template)"
    >
      <div class="mine-card-main">
        <div class="d-flex flex-wrap align-items-center gap-2 mb-2">
          <h2 class="mine-card-title mb-0">{{ template.title }}</h2>
          <span class="status-chip" [attr.data-status]="template.status">
            {{ statusLabel(template.status) }}
          </span>
          <span class="version-chip">v{{ template.version }}</span>
        </div>
        <div class="mine-submeta">
          <span class="game-label">{{ template.game || 'Unknown game' }}</span>
          <span
            class="revision-meta"
            *ngIf="template.updated_at || template.created_at"
          >
            <mat-icon>history</mat-icon>
            <time [attr.datetime]="template.updated_at || template.created_at">
              {{ (template.updated_at || template.created_at) | date: 'd MMM y' }}
            </time>
          </span>
        </div>
        <p class="mine-card-description">{{ template.description }}</p>
      </div>
      <div class="mine-card-meta">
        <span *ngIf="template.status === 'approved'">
          <mat-icon>thumb_up</mat-icon> {{ template.like_count }}
        </span>
        <mat-icon class="chevron">chevron_right</mat-icon>
      </div>
    </button>
  </div>
</div>
